// extracted by mini-css-extract-plugin
module.exports = {"mobileHeight":"screen and (max-height: 824px)","root":"BotHeadSpin_root__2L4Gh","rotate":"BotHeadSpin_rotate__1mE57","inPanel":"BotHeadSpin_inPanel__1ZcqG"};